import { Link } from "react-router-dom";
import { IconButton } from "@mui/material";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

export const IconLinkButton = ({
  to,
  replace,
  IconElement = PencilSquareIcon, // Default icon
}: {
  to: string;
  IconElement?: any;
  replace?: boolean;
}) => {
  const onClick = (e: React.MouseEvent) => {
    // Prevent the click on row from adding history entry twice
    e.stopPropagation();
  };

  return (
    <Link to={to} replace={replace} onClick={onClick}>
      <IconButton color="primary">
        <IconElement width={18} height={18} />
      </IconButton>
    </Link>
  );
};
